var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"d-flex h-100 w-100"},[_c('div',{staticClass:"col-md-3"},[_c('searchReports',{on:{"search":function($event){_vm.formSearch = $event},"contapatologia":function($event){_vm.contapatologia = $event}}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-9"},[_c('chartReports',{attrs:{"formSearch":_vm.formSearch,"contapatologia":_vm.contapatologia}})],1)])])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-80fa065c","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/private/realestate/reports/reports.vue
// module id = null
// module chunks = 